import * as Sentry from '@sentry/react'

import keycloak from './keycloak'

export const syncSentryUser = () => {
	const email = keycloak.authenticated ? keycloak.tokenParsed?.email : undefined
	const name = keycloak.authenticated ? keycloak.tokenParsed?.name : undefined

	const userEmail = typeof email === 'string' ? email.trim() : ''
	const userName = typeof name === 'string' ? name.trim() : ''

	Sentry.setUser(
		userEmail
			? {
					id: userEmail,
					email: userEmail,
					name: userName
			  }
			: null
	)
}

export function clearSentryUser() {
	Sentry.setUser(null)
}
